import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

import welcomeBonusCrown from '../../../assets/images/landing/welcome-bonus-crown.png';
import { __ } from '../../../i18n/l10n';
import { Icon } from '../../shared/components/Icon';
import Spacer from '../../shared/components/Spacer';

const Modal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ImageContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const BonusPromoImage = styled.img`
width: 100%;
height: auto;
border-radius: 1em;
border: 1px solid rgba(255, 255, 255, 0.14);
box-sizing: border-box,
`;

const InfoIconContainer = styled.div`
position: absolute;
bottom: 10px;
right: 10px;
background-color: rgba(255, 255, 255, 0.14);
border-radius: 2.14em;
cursor: pointer;
box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
width: 20px;
height: 20px;
display: flex;
align-items: center;
justify-content: center;
`;

const InfoIcon = styled(Icon)`
justify-content: center;
align-items: center;
`;

const ModalTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalTitle = styled.div`
  font-size: 1.5rem;
`;

const BulletPoints = styled.div`
  
`;

const BulletPoint = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Link = styled.a``;

const WelcomeBonusModalInfo = () => (
  <Modal>
    <ModalTitleContainer>
      <img src={welcomeBonusCrown} />
      <Spacer width={'10px'} />
      <ModalTitle>{__('Welcome bonus')}</ModalTitle>
    </ModalTitleContainer>
    <Spacer height={'10px'} />
    <BulletPoints>
      <BulletPoint>
        <p>{'🚀'}</p>
        <Spacer width={'10px'} />
        <p>{__('Your first bet refunded in cash if it loses')}</p>
      </BulletPoint>
      <BulletPoint>
        <p>{'💰'}</p>
        <Spacer width={'10px'} />
        <p>{__('Up to a limit of €100 or the same amount as your first deposit')}</p>
      </BulletPoint>
      <BulletPoint>
        <p>{'🔥'}</p>
        <Spacer width={'10px'} />
        <p>{__('Withdrawable cash credited to your account directly after the result of the first bet')}</p>
      </BulletPoint>
    </BulletPoints>
    <Spacer height={'10px'} />
    <Link href={'https://www.winamax.fr/offre_bienvenue'}>{__('Terms and Conditions')}</Link>
    <Spacer height={20} />
  </Modal>
);

export default WelcomeBonusModalInfo;
